const ExecutiveDiagramFrame = ({ theme, children, caption, className = '' }) => {
  const isDark = theme === 'dark';

  return (
    <figure className={className}>
      <div
        className={`rounded-xl border overflow-hidden ${
          isDark ? 'border-slate-700/80 bg-slate-950' : 'border-slate-300 bg-white shadow-sm'
        }`}
      >
        {children}
      </div>
      {caption && (
        <figcaption
          className={`mt-3 text-[11px] uppercase tracking-[0.2em] text-center font-medium ${
            isDark ? 'text-slate-500' : 'text-slate-600'
          }`}
        >
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default ExecutiveDiagramFrame;
